import { DatePipe } from '@angular/common';
import {Component, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaimsBaseComponent } from 'src/app/claim-pages/claim-base.component';
import { TransactionInfo } from 'src/app/model/transaction-info.model';
import { SideMenuService } from 'src/app/services/side-menu.service';
import { StoredDataService } from 'src/app/services/stored-data-service';
import { TransactionInfoService } from 'src/app/services/transaction-info.service';

@Component({
    selector: 'app-acknowledgement',
    templateUrl: './acknowledgement.component.html',
    styleUrls: ['./acknowledgement.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AcknowledgementComponent extends ClaimsBaseComponent implements OnInit {

    transactionInfo : TransactionInfo;
    policyHolder: string;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private injector : Injector,
                private transactionInfoService: TransactionInfoService,
                private storedDataService : StoredDataService,
                public sideMenuService: SideMenuService) {
        super(injector);
        this.transactionInfo = this.transactionInfoService.getTransactionInfo();
    }

    ngOnInit() {
        this.policyHolder = this.claim.getClaimantName() ? this.claim.getClaimantName() : this.claim.getPolicyHolderName();
    }

    goToNext() {
        this.sideMenuService.emitProgress(1);
        let route = "";
        if (this.transactionInfo.isAccidentProduct()) {
            if (this.transactionInfo.hasSingleInsured()) {
                route = "/claimform/paDetailsOfAccident";
            } else {
                route = "/claimform/selectInsured";
            }
        } else if (this.transactionInfo.isTravelProduct()) {
            route = "/claimform/confirmTravelPeriod";
        } else if (this.transactionInfo.isHomeProduct()) {
            route = "/claimform/confirmIncidentDetails";
        }
        this.router.navigate([route], {
            relativeTo: this.activatedRoute
        });
    }

    cancel() {
        this.storedDataService.clearSession();
        window.location.href = decodeURIComponent(this.claim.getCallbackUrl());
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd MMM yyyy");
        } else {
            return "";
        }
    }
}
